import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const CategoryEdit = React.lazy(() => import("@mediaspace/features/category-edit"));

export const ManageContentTab = React.lazy(
    () => import("@mediaspace/features/category-edit/tabs/manage-content-tab/ManageContentTab")
);
export const DetailsTab = React.lazy(() => import("@mediaspace/features/category-edit/tabs/details-tab/DetailsTab"));
export const BrandingTab = React.lazy(() => import("@mediaspace/features/category-edit/tabs/branding-tab/BrandingTab"));
export const SettingsTab = React.lazy(() => import("@mediaspace/features/category-edit/tabs/settings-tab/SettingsTab"));

export const render = getDsLayoutComponentRenderer(CategoryEdit);
